<template lang="pug">
  section.scene-achievement
    transition( name="headline" )
      headline(
        v-if="displayStatus==='headline'",
        :en="headline.en",
        :jp="headline.jp"
      )

    transition( name="description" )
      .contents( v-if="displayStatus==='contents'" )
        step-place(
          v-if="step==='place'"
          :placeList="place.placeList",
          :isPlaceLoading="place.isPlaceLoading",
          :isPlaceSelected="place.isPlaceSelected",
          @onSearch="onStepPlace_Search",
          @onSearch_GPS="onStepPlace_Search_GPS",
          @onSelect="onStepPlace_Select",
          @onFix="onStepPlace_Fix",
          @onReset="onStepPlace_Reset"
        )
        step-member(
          v-if="step==='member'",
          @onUpdate="onStepMember_Update",
          @onFix="onStepMember_Fix",
          @onBack="onStepMember_Back"
        )
        step-date(
          v-if="step==='date'",
          @onUpdate="onStepDate_Update",
          @onFix="onStepDate_Fix",
          @onBack="onStepDate_Back"
        )
        step-distance(
          v-if="step==='distance'",
          @onUpdate="onStepDistance_Update",
          @onFix="onStepDistance_Fix",
          @onBack="onStepDistance_Back"
        )
    transition( name="loading" )
      .loading( v-if="isLoading")
        i.fas.fa-cog.fa-spin
</template>

<script>
import GameMain from "../game/GameMain";
import Common from "./mixins/Common";

import Headline from "./Headline";
import StepPlace from "./scene_achievement/StepPlace";
import StepMember from "./scene_achievement/StepMember";
import StepDistance from "./scene_achievement/StepDistance";
import StepDate from "./scene_achievement/StepDate";

export default {
  mixins: [Common],

  components: {
    Headline,
    StepPlace,
    StepMember,
    StepDistance,
    StepDate
  },

  data() {
    return {
      place: {
        placeList: [],
        isPlaceLoading: false,
        isPlaceSelected: false
      },
      member: 0,
      distance: 0,
      date: null,
      isLoading: false,
      isFullPage: true
    };
  },

  watch: {
    step: function(val) {
      //send GA Events
      this.$ga.page("/scene_achievement/" + val);

      switch (val) {
        case "place":
          this.headline.en =
            "Where will you be<br/>when you achieve that Goal?";
          this.headline.jp = "目標はどこで達成する？";

          this.onStepPlace_Reset();
          this.onStepMember_Update(0);

          this.showHeadline();
          GameMain.sceneAchievement_changeStep(val);
          break;
        case "member":
          this.headline.en = "How many members are you with?";
          this.headline.jp = "何人の仲間と一緒に達成する？";

          this.onStepMember_Update(0);
          this.onStepDate_Update(new Date(2019, 11, 31));

          this.showHeadline();
          GameMain.sceneAchievement_changeStep(val);
          break;
        case "date":
          this.headline.en = "How long do you want<br/>to achieve that Goal?";
          this.headline.jp = "いつまでに達成したい？";

          this.onStepDate_Update(new Date(2019, 11, 31));
          this.onStepDistance_Update(0);

          this.showHeadline();
          GameMain.sceneAchievement_changeStep(val);
          break;
        case "distance":
          this.headline.en = "How far is it to the Goal?";
          this.headline.jp = "目標までの距離はどれぐらい？";

          this.onStepDistance_Update(0);

          this.showHeadline();
          GameMain.sceneAchievement_changeStep(val);
          break;
        case "end":
          GameMain.sceneAchievement_changeStep(val);
          break;
      }
    }
  },

  mounted() {
    this.step = "place";
  },

  methods: {
    //------------------------------------
    // Step2：Place
    //------------------------------------
    onStepPlace_Search(address) {
      this.isLoading = true;

      GameMain.sceneAchievement_searchMap(address).then(placeList => {
        if (placeList) this.place.placeList = placeList;
        else this.place.placeList = [];
        this.isLoading = false;
      });
    },

    onStepPlace_Search_GPS() {
      //send GA Events
      this.$ga.event("scene_achievement", "place", "GPS", 1);
    },

    async onStepPlace_Select(place) {
      this.place.isPlaceLoading = true;

      this.isLoading = true;

      await GameMain.sceneAchievement_loadMap(
        place._attr.lat._value,
        place._attr.lon._value
      );

      this.isLoading = false;

      setTimeout(() => {
        this.place.isPlaceSelected = true;
      }, 5000);

      //send GA Events
      this.$ga.event("scene_achievement", "place", "select", 1);
    },

    onStepPlace_Reset() {
      this.place.isPlaceLoading = false;
      this.place.isPlaceSelected = false;
      this.place.placeList = [];
      GameMain.sceneAchievement_resetMap();

      //send GA Events
      this.$ga.event("scene_achievement", "place", "reset", 1);
    },

    onStepPlace_Fix() {
      this.step = "member";
    },

    //------------------------------------
    // Step3：Member
    //------------------------------------
    onStepMember_Update(number) {
      this.member = number;
      GameMain.sceneAchievement_changeMember(number);
    },

    onStepMember_Fix() {
      this.step = "date";
    },

    onStepMember_Back() {
      this.step = "place";
    },

    //------------------------------------
    // Step4：Date
    //------------------------------------
    onStepDate_Update(date) {
      this.date = date;
      GameMain.sceneAchievement_changeDate(date);
    },

    onStepDate_Fix(date) {
      this.date = date;
      GameMain.sceneAchievement_changeDate(date);
      this.step = "distance";
    },

    onStepDate_Back() {
      this.step = "member";
    },

    //------------------------------------
    // Step5：Distance
    //------------------------------------
    onStepDistance_Update(distance) {
      this.distance = distance;
      GameMain.sceneAchievement_changeDistance(distance);
    },

    onStepDistance_Fix() {
      this.step = "end";
      this.$emit("onSceneNext");
    },

    onStepDistance_Back() {
      this.step = "date";
    }
  }
};
</script>

<style scoped lang="scss">
.loading-enter-active,
.loading-leave-active {
  transition: all 500ms ease;
}
.loading-enter {
  opacity: 0;
}

.loading-leave-to {
  opacity: 0;
}

.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 4rem;
  color: #fff;
}
</style>
